import { useEffect, useState } from "react"
import { BasicPage } from "../../theme/Component/BasicPage"
import { _DocumentFactory, _single, _UBLInvoice } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { Modal } from "../../theme/Component/Modal"
import { BasicTable, MASK_BOOLEAN, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable"
import { AccountEditor } from "../../editor/AccountEditor"
import usePaginator from "../../theme/Component/usePaginator"
import { YearSelector } from "../../../core/shared/inputs/YearSelector"
import { MonthConstantsEditor } from "../../RemoteAbstractAction/editors/MonthConstantsEditor"
import { SelectUBLDocumentTypeConstants } from "./Selectores/SelectUBLDocumentTypeConstants"
import { SelectDocumentStateConstants } from "./Selectores/SelectDocumentStateConstants"
import { ListMenu } from "../../theme/Component/ListMenu"
import { FireElectronicDocument } from "../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/FireElectronicDocument"
import { CreateUBLInvoiceItems } from "../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/CreateUBLInvoiveItem"
import { AccountantDocumentList } from "../../contract/etapa-contrato/contrac/ublinvoice/AccountantDocumentList/AccountantDocumentList"
import { HistoryUBLInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/HistoryUBLInvoice"
import { FileService } from "../../../core/services/FileService"
import { MakeUBLInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice"
import { BasicButton } from "../../theme/Component/BasicButton"
import { InputDate } from "../../theme/Input/InputDate"
import { DocumentPDF, DocumentViewer } from "../../theme/Component/DocumentViewer"
import { toast } from "react-toastify"
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor"
import { BasicSwitch } from "../../theme/Component/BasicSwitch"
import { PrepaidPaymentEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/ComponentPrepaidPayment/PrepaidPaymentEditor"
import { ReciablePaymentEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/ComponentPrepaidPayment/ReciablePaymentEditor"
import { UBLInvoiceTaxSupplier } from "../../contract/etapa-contrato/contrac/UBLInvoiceSupplier/Component/UBLInvoiceTax/UBLInvoiceTaxSupplier"
import { InputMoney } from "../../theme/Input/InputMoney"
import { SelectAccountantConceptCatalogForSupplierInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSupplierInvoice"
import { SelectAccountantConceptCatalogForSalesInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSalesInvoice"
import { FileInput } from "../../theme/Component/FileInput"
import { PrintJson } from "../../theme/Component/PrintJson"
import { CurrencyEditor } from "../../erp/cellEditor/Currency/CurrencyEditor"
import { SelectUBLDocumentPaymentType } from "../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/Components/SelectUBLDocumentPaymentType"
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal"
import { SelectUBLAccountingDocumentTypes } from "./Selectores/SelectUBLAccountingDocumentTypes"
import { DocumentStorageEditor } from "../bodegaDocumentos/DocumentStorageEditor"
import { UBLPayment } from "./UBLPayment/UBLPayment"
import { SelectUBLSoftwareDispatcherByEnvironmentType } from "../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/Selectores/SelectUBLSoftwareDispatcherByEnvironmentType"
import { UBLNotification } from "../../contract/etapa-contrato/contrac/ublinvoice/UBLNotification/UBLNotification";
import { VisorAnyDocument } from "../../documents/VisorAnyDocument";

interface Form {
    IDAccountSupplier: number;
    IDAccountCustomer: number;
    UblDocumentType: number;
    Year: number;
    IDAccountantConcept: any;
    Month: number;
    State: number;
    DocumentYpe: string;
    IDDocument: number;
    DocumentDate: any;
}

const PURCHASE_INVOICE = 0;
const BILL_OF_SALE = 1;

export const UblInvoiceCatalog = () => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_UBLInvoice);
    const fileService = new FileService();
    const [response, setResponse] = useState<Partial<Form>>({
        Year: _single.getCurrenYear(),
    });
    const [formato, setFormato] = useState<any>(null)
    const [type, settype] = useState<any>([]);
    const paginador = usePaginator();
    const [documentError, setDocumentError] = useState<any>([]);
    const [recordDate, setRecordDate] = useState<any>();
    const [fileType, setFileType] = useState<string>(null);
    const [Ubltipe, setUbltipe] = useState<any>(1);
    const [donwloadURL, setDonwloadURL] = useState<string>(null);
    const [urlFile, setUrlFile] = useState<string | null>(null);
    const [document, setDocument] = useState<any>([]);
    const [store, setStore] = useState<number>(null);
    const [ublsoftware, setUblSofteare] = useState<number>();

    useEffect(() => {
        if (donwloadURL) {
            const fetchPdf = async () => {
                try {
                    const data = await fileService.getPdfAsBase642(donwloadURL);
                    setUrlFile(data);
                } catch (error) {
                    console.error('Error loading PDF:', error);
                }
            };

            fetchPdf();
        }
    }, [donwloadURL]);

    useEffect(() => {
        setFileType(bean.Media?.split('.').pop())
        setDonwloadURL(fileService.getUrlFile(bean.MediaContext, bean.Media))
    }, [bean])



    useEffect(() => {
        setLista([])
        getLista()
    }, [paginador.page, Ubltipe])

    const getLista = () => {
        instance.getUblInvoiceCatalogForReport(response.IDAccountSupplier, response.IDAccountCustomer, Ubltipe, response.Year, response.Month, response.State, null, response.DocumentYpe, response.IDDocument, response.DocumentDate, response.IDAccountantConcept, paginador.page, 15).then(
            (resp) => {
                console.log(resp)
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountCustomerNit ?? "") + "-" + (user.DataBeanProperties.AccountCustomerName ?? "");
                        user.DataBeanProperties.Doc = `${user.DataBeanProperties.FCIDDocument ? `${user.DataBeanProperties.FCMnemonic ?? ""} - ${user.DataBeanProperties.FCConsecutive ?? ""} - ${user.DataBeanProperties.FCDate ?? ""}` : "N/A"}`
                        user.DataBeanProperties.Remision = `${user.DataBeanProperties.EAFConsecutive ? `${user.DataBeanProperties.EAFMnemonic ?? ""} - ${user.DataBeanProperties.EAFConsecutive ?? ""} - ${user.DataBeanProperties.EAFDate ?? ""}` : "N/A"}`
                        user.DataBeanProperties.Obligation = `${user.DataBeanProperties.OBConsecutive ? `${user.DataBeanProperties.OBMnemonic ?? ""} - ${user.DataBeanProperties.OBConsecutive ?? ""} - ${user.DataBeanProperties.OBDate ?? ""}` : "N/A"}`
                    });
                    setLista(x)
                }
            }
        ).catch(err => { console.log(err) })
    }

    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Nit-Cliente', property: 'Client', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Nit - Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Aplicar Anticipo', property: 'ApplyPrepaidValue', visible: true, mask: MASK_BOOLEAN },
        { title: 'Valor del Anticipo', property: 'PrepaidPayment', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Documento Factura', property: 'Doc', visible: true },
        { title: 'Documento Obligacion', property: 'Obligation', visible: true },
        { title: 'Entrada de Almacén/Remisión', property: 'Remision', visible: true },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true, mask: MASK_BOOLEAN },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentTypeName', visible: true },
        { title: 'Días de Vencimiento', property: 'DefeatDays', visible: true },
        { title: 'Utilizar Otra Moneda', property: 'UseOtherCurrency', visible: true },
        { title: 'Moneda de la Transacción', property: 'CurrencyName', visible: true },
        { title: 'Tasa de cambio', property: 'ExchangeRate', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
    ]

    const [modalfac, setModalfac] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalB, setModalB] = useState<any>({ view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalPro, setModalPro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalFire, setModalFire] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalSeeDoc, setModalSeeDoc] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalUBL, setModalUBL] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalAccounting, setModalAccounting] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalVisor, setModalVisor] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalEntry, setModalEntry] = useState<any>({ name: 'Generar Entrada', view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalPrepaid, setModalPrepaid] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalApplyPrepaid, setModalApplyPrepaid] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalRetenciones, setModalRetenciones] = useState<any>({ view: false, btnClose: true, btnSubmit: false, format: 'modal-xl' });
    const [modalDescription, setModalDescription] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConcept, setModalConcept] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalDocument, setModalDocument] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalConfig = useModal("Especificar Divisa", MODAL_md);
    const modalConfig2 = useModal("Terminos de Pago", MODAL_md);
    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const modalRadian = useModal("Eventos Radian", MODAL_LG);

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver pagos de Factura', icono: 'ri-list-ordered', visible: _single.canView(), evento: () => { setModalfac({ ...modalfac, "view": true, "name": `Ver pagos de Factura` }) } },
            { titulo: 'Eventos Radian', icono: 'ri-list-check', visible: _single.canView(), evento: () => { modalRadian.open() } },
            { titulo: 'ver Items de la Factura', icono: 'ri-list-ordered', visible: _single.canEdit(), evento: () => { setModalB({ ...modalB, "view": true, "name": `Items de la Factura` }) } },
            { titulo: 'Generar Factura Proforma', icono: 'ri-swap-box-line', visible: true, evento: () => { setModalPro({ ...modalPro, "view": true }) } },
            { titulo: 'Ver Retenciones de la Factura', icono: 'ri-list-ordered', visible: bean.UBLDocumentType === 0 && _single.canEdit(), evento: () => { setModalRetenciones({ ...modalRetenciones, "view": true, "name": `Items de la Factura ${bean.IDUBLInvoice}` }) } },
            { titulo: 'Ver Documentos Contables', icono: 'ri-list-ordered', visible: _single.canView(), evento: () => { setModalSeeDoc({ ...modalSeeDoc, "view": true, "name": `Ver Documentos Contables` }) } },
            { titulo: 'Ver eventos en la Factura', icono: 'ri-history-line', visible: _single.canView(), evento: () => { setModalC({ ...modalC, "view": true, "name": "Ver eventos en la Factura" }) } },
            { titulo: 'Abrir Documento de Factura', icono: 'ri-file-list-line', visible: _single.canView(), evento: () => { setModal({ ...modal, "name": "Abrir archivo", "view": true, "format": `${fileType !== "pdf" && "jpg" && "png" ? "modal-md" : "modal-xl"}` }) } },
            { titulo: 'Agregar/Modificar Documento de Factura', icono: 'ri-swap-line', visible: _single.canEdit(), evento: () => { setModalDocument({ ...modalDocument, "name": "Modificar Documento Cargado", "view": true }) } },
            { titulo: 'Especificar Divisa', icono: 'ri-money-dollar-box-line', visible: _single.canEdit(), evento: () => { modalConfig.open() } },
            { titulo: 'Terminos de Pago', icono: 'ri-money-dollar-box-line', visible: _single.canEdit(), evento: () => { modalConfig2.open() } },
            { titulo: 'Crear/Modificar Objeto de Factura', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { setModalDescription({ ...modalDescription, "name": "Crear/Modificar Objeto de Factura", "view": true }) } },
            { titulo: 'Crear/Modificar Concepto de Ingreso', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { setModalConcept({ ...modalConcept, "name": "Crear/Modificar Concepto de Ingreso", "view": true }) } },
            { titulo: 'Cruzar Anticipo', icono: 'ri-swap-box-line', visible: bean.UBLDocumentType === 1 && _single.canEdit(), evento: () => { setModalPrepaid({ ...modalPrepaid, "view": true, "name": "Cruzar Anticipo" }) } },
            { titulo: 'Aplicar Anticipo', icono: 'ri-money-dollar-circle-line', visible: (bean.ApplyPrepaidValue === true && bean.UBLDocumentType === 1) && _single.canEdit(), evento: () => { setModalApplyPrepaid({ ...modalApplyPrepaid, "view": true, "name": "Aplicar Anticipo" }) } },
            { titulo: 'Transmitir/Descargar Documento Electrónico', icono: 'ri-list-ordered', visible: _single.canEdit(), evento: () => { setModalFire({ ...modalFire, "view": true, "name": `Transmitir/Descargar Documento` }) } },
            { titulo: 'Generar Causación Contable', icono: 'ri-save-line', visible: _single.canEdit(), evento: () => { setModalAccounting({ ...modalAccounting, "view": true, "name": `Generar Causación Contable` }) } },
            { titulo: 'Generar Entrada a Activos Fijos', icono: 'ri-save-line', visible: bean.UBLDocumentType === 1 && _single.canEdit(), evento: () => { setModalEntry({ ...modalEntry, "view": true, "name": `Generar Entrada Almacen` }) } },
            { titulo: 'Anular', icono: 'ri-forbid-line', visible: _single.canDelete(), evento: () => { setModalConfirm({ ...ModalConfirm, "view": true, "name": "Anular Factura" }); } },
        ]

        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: (_single.canCreate() && response.Year), icono: 'ri-file-add-line', evento: () => { setModalUBL({ ...modalUBL, "view": true, "name": "Agregar Factura Electronica" }) } }
    ]

    const getFileType = (mediaName: string) => {
        let fileType = mediaName.split('.').pop()?.toLowerCase();
        return fileType;
    }

    const getElectronicDocumentProforma = () => {

        instance.getElectronicDocumentProforma(
            bean.IDUBLInvoice,
            bean.IssueDate,
            _single.getAccountID(),
            ublsoftware
        ).then((resp: any) => {

            console.log("RESP:", resp);

            let data = resp;

            // 🔥 VALIDACIÓN CLAVE
            if (!data?.MediaContext || !data?.Media) {
                console.warn("No viene MediaContext o Media");
                toast.error("No se encontró el documento para visualizar");
                return; // ⛔ corta ejecución
            }

            const url = fileService.getUrlFile(data.MediaContext, data.Media);
            const type = getFileType(data.Media);

            settype(type);
            setFormato(url);

            // 🔥 primero cerrar
            setModalPro(prev => ({ ...prev, view: false }));

            // 🔥 luego abrir
            setTimeout(() => {
                setModalviewdoc(prev => ({ ...prev, view: true }));
            }, 100);

        }).catch(err => {
            console.error(err);
            toast.error(err);
        });
    };
    const update = () => {
        setModalUBL({ ...modalUBL, "view": false });
        getLista();
    }

    const [ModalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const nullUBL = () => {
        instance.nullifyUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, _single.getAccountID(), obs).then(
            (resp) => {
                getLista();
                if (resp.length > 0) {
                    resp.map((e) => {
                        setModalConfirm({ ...ModalConfirm, "view": false });
                        toast.info(e, { autoClose: false });
                    });
                } else {
                    toast.error("No se ha podido anular la factura.")
                }
            }
        ).catch(
            err => {
                console.log(err);
            }
        )
    }

    const createAccountantDocumentForUBLInvoice = () => {
        instance.createAccountantDocumentForUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, recordDate, _single.getAccountID())
            .then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList) {
                        setDocumentError(resp.MsgList);
                    }
                    if (resp.DocumentURL) {
                        let docs: DocumentPDF[] = [];
                        resp.DocumentURL.forEach(element => {
                            docs.push({
                                Filename: element.DataBeanProperties.Filename,
                                Media: element.DataBeanProperties.Media,
                                MediaContext: element.DataBeanProperties.MediaContext,
                                Type: element.DataBeanProperties.Type,
                                URLLink: element.DataBeanProperties.URLLink
                            })
                        });
                        setDocument(docs);
                    }
                    setModalVisor({ ...modalVisor, "view": true, "name": "Causación Contable" });
                    setModalAccounting({ ...modalAccounting, "view": false });
                    setModal({ ...modal, "view": false });
                    getLista();
                }
            ).catch(err => toast.error(err));
    }

    const generateEntry = () => {
        instance.createFixedAssetEntryForUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, _single.getCurrenDate(), store, _single.getAccountID()).then(
            (resp: any) => {
                //console.log(resp);
                if (resp.MsgList) {
                    setDocumentError(resp.MsgList);
                }
                if (resp.DocumentURL) {
                    let docs: DocumentPDF[] = [];
                    resp.DocumentURL.forEach(element => {
                        docs.push({
                            Filename: element.DataBeanProperties.Filename,
                            Media: element.DataBeanProperties.Media,
                            MediaContext: element.DataBeanProperties.MediaContext,
                            Type: element.DataBeanProperties.Type,
                            URLLink: element.DataBeanProperties.URLLink
                        })
                    });
                    setDocument(docs);
                }
                setModalVisor({ ...modalVisor, "view": true, "name": "Documento de Entrada" });
                setModalEntry({ ...modalEntry, "view": false });
                setModal({ ...modal, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err)
                toast.error("No se Pudo Realizar la Accion")
            }
        )
    }

    const [obs, setObs] = useState<string>("");

    const applyPreapid = () => {
        if (bean.ApplyPrepaidValue) {
            if (!bean.PrepaidIDAccountantStr || bean.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!bean.PrepaidPayment || isNaN(bean.PrepaidPayment) || bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }

        instance.applyPrepaidPayment(
            bean.IDUBLInvoice,
            bean.IssueDate,
            bean.ApplyPrepaidValue,
            bean.ApplyPrepaidValue ? bean.PrepaidIDAccountantStr : null,
            bean.ApplyPrepaidValue ? bean.PrepaidPayment : null
        ).then(() => {
            getLista();
            setModalPrepaid({ ...modalPrepaid, "view": false });
        }).catch(err => {
            console.log(err);
            toast.error("No se pudo realizar la acción.");
        });
    };

    const updateInvoice = () => {
        if (bean.ApplyPrepaidValue) {
            if (!bean.PrepaidIDAccountantStr || bean.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!bean.PrepaidPayment || isNaN(bean.PrepaidPayment) || bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }

        instance.updateUBLInvoice(bean).then(() => {
            getLista();
            setModalApplyPrepaid({ ...modalApplyPrepaid, "view": false });
            setModalDocument({ ...modalDocument, view: false });
        }).catch(err => {
            console.log(err);
            toast.error("No se pudo realizar la acción.");
        });
    };

    const updateDesciption = () => {
        instance.setDescriptionToUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, bean.Description).then(
            (resp) => {
                getLista();
                setModalDescription({ ...modalDescription, view: false });
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const updateAccountantConcept = () => {
        instance.setAccountantConceptToUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, bean.IDAccountantConcept).then(
            (resp) => {
                getLista();
                setModalConcept({ ...modalConcept, view: false });
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    return (
        <BasicPage titulo="Reporte de Facturas de Venta">
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccountSupplier} label="Proveedor" onChange={(e) => { setResponse({ ...response, "IDAccountSupplier": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccountCustomer} label="Cliente" onChange={(e) => { setResponse({ ...response, "IDAccountCustomer": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <SelectUBLDocumentTypeConstants disable={true} idSelect={Ubltipe} onChange={(e) => { setUbltipe(e) }} label="Tipo de Documento" />
                </div>
                <div className="col-md-6">
                    <YearSelector value={response.Year} onChange={(e) => { setResponse({ ...response, "Year": e }) }} tittle="Vigencia" />
                </div>
                <div className="col-md-6">
                    <MonthConstantsEditor idSelect={response.Month} onChange={(e) => { setResponse({ ...response, "Month": e }) }} label="Mes" name="Month" />
                </div>
                <div className="col-md-6">
                    <SelectDocumentStateConstants idSelect={response.State} onChange={(e) => { setResponse({ ...response, "State": e }) }} label="Estado" />
                </div>
                <div className="col-md-6">
                    <SelectAccountantConceptCatalogForSalesInvoice label='Concepto de Factura de Venta' idSelector={response.IDAccountantConcept} onChange={(e) => { setResponse({ ...response, "IDAccountantConcept": e }) }} />
                </div>
                <div className="col-md-6">
                    <SelectUBLAccountingDocumentTypes idSelect={response.DocumentYpe} onChange={(e) => { setResponse({ ...response, DocumentYpe: e }) }} label="Tipo Documento Contable" />
                </div>
                <div className="col-md-6">
                    <DocumentStorageEditor label="Selector de Documentos" mNemonic={response.DocumentYpe} onChange={(e) => { setResponse({ ...response, IDDocument: e.IDDocument, DocumentDate: e.DocumentDate }) }} />
                </div>

            </div>
            <div className="row mt-4">
                <div className="col-md-4">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} />
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <BasicTable
                        iconButtons={iconButtonsItem}
                        listButtons={listaBotones()}
                        head={head}
                        body={lista}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>
            </div>

            <Modal modal={modalB} updateModal={setModalB} >
                <CreateUBLInvoiceItems idUBLInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} _onChange={() => { getLista(); }} />
            </Modal>
            <Modal modal={modalfac} updateModal={setModalfac} >
                <>
                    <UBLPayment idUBLInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} />
                </>
            </Modal>
            <Modal modal={modal} updateModal={setModal} eventModal={() => { }} >
                <div className="row">
                    <div className="col-md-12">
                        <div className="iframe-container">

                            {fileType ?
                                <>
                                    {fileType === 'pdf' && (
                                        urlFile ? (
                                            <>
                                                aqui
                                                <iframe name="pdfviwer" src={urlFile} onError={(e) => console.error('Error loading PDF:', e)}></iframe>
                                            </>
                                        ) : (
                                            <p>Cargando PDF...</p>
                                        )
                                    )}
                                    {fileType === `"jpg"` || fileType === "png" &&
                                        (
                                            <img src={urlFile} alt="Image Preview" width="100%" />
                                        )
                                    }
                                    {fileType !== "pdf" && "jpg" && "png" &&
                                        <>
                                            <a href={donwloadURL} target='_blank'>Clic aquí para descargar el archivo {bean.Media}</a>
                                        </>
                                    }
                                </>
                                :
                                <>
                                    No se pudo cargar el Documento
                                </>
                            }
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalC} updateModal={setModalC} >
                <HistoryUBLInvoice _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalFire} updateModal={setModalFire} >
                <FireElectronicDocument _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalSeeDoc} updateModal={setModalSeeDoc} >
                <AccountantDocumentList _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalRadian.modal} updateModal={modalRadian.setModal} >
                <UBLNotification ublInvoice={bean} />
            </Modal>

            <Modal modal={modalDescription} updateModal={setModalDescription} eventModal={() => { updateDesciption() }} >
                <div className="row">
                    <div className="col-md-12">
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalConcept} updateModal={setModalConcept} eventModal={() => { updateAccountantConcept() }} >
                <div className="row">
                    {bean.UBLDocumentType == BILL_OF_SALE &&
                        <div className="col-md-12">
                            <label>Concepto de Ingreso de Facturación de Venta</label>
                            <SelectAccountantConceptCatalogForSalesInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
                        </div>
                    }
                    {bean.UBLDocumentType == PURCHASE_INVOICE &&
                        <div className="col-md-12">
                            <label>Concepto de Ingreso de Facturación Proveedor</label>
                            <SelectAccountantConceptCatalogForSupplierInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
                        </div>
                    }
                </div>
            </Modal>

            <Modal modal={modalDocument} updateModal={setModalDocument} eventModal={() => { updateInvoice() }} >
                <div className="row">
                    <div className="col-md-12">
                        <label>No Factura</label>
                        <input type="text" className="form-control" value={bean.InvoiceID} onChange={(e) => { setBean({ ...bean, InvoiceID: e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <FileInput onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }} Media={bean.Media} MediaContext={bean.MediaContext} label={bean.Media ? "Documento de la Factura Cargada" : "Cargar Documento de Factura"} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalUBL} updateModal={setModalUBL} 
                // eventModal={() => { update() }} 
                evenOnClose={()=>{update()}} >
                <MakeUBLInvoice catalog _onChange={(e) => { _single.printOut(e) }} />
            </Modal>

            <Modal modal={modalAccounting} updateModal={setModalAccounting} eventModal={createAccountantDocumentForUBLInvoice} onSubmitLabel="Procesar">
                <div className="row">
                    <div className="col-md-12">
                        <InputDate label="Fecha de registro contable" name="date" value={recordDate} setDate={setRecordDate} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalVisor} updateModal={setModalVisor} >
                {/* visor de documentos */}
                <div className="row">
                    <div className="col-md-12">
                        {documentError.length > 0 ?
                            // <PrintJson json={documentError} />
                            <ul className="group-list">
                                {documentError.map((item: any, index: number) => {
                                    return (
                                        <li key={index} className="group-list-item">{item}</li>
                                    )
                                })}
                            </ul>
                            :
                            <>
                                {document.length > 0 &&
                                    <DocumentViewer list={document} />
                                }
                            </>
                        }
                    </div>
                </div>
            </Modal>

            <Modal modal={modalEntry} updateModal={setModalEntry} onSubmitLabel="Generar Entrada"
                eventModal={() => {
                    if (store == null || store == undefined || isNaN(store)) {
                        toast.error("Debe Seleccionar un almacen");
                    } else {
                        generateEntry();
                    }
                }}
            >
                <SelectStoreEditor idSelector={store} onChange={(e) => { setStore(e.IDStore) }} />
            </Modal>


            <Modal modal={modalPrepaid} updateModal={setModalPrepaid} eventModal={() => { applyPreapid() }}  >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Aplicar Anticipo" estado={bean.ApplyPrepaidValue} eventChange={(e) => { setBean({ ...bean, "ApplyPrepaidValue": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <PrepaidPaymentEditor _Invoice={bean} onChange={(e) => { setBean({ ...bean, "PrepaidIDAccountantStr": e.JsonCode }) }} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _value={bean.PrepaidPayment} onChange={(e) => { setBean({ ...bean, "PrepaidPayment": e }) }} _label="Valor del Anticipo a Cruzar" />
                    </div>
                </div>
            </Modal>

            <Modal modal={ModalConfirm} updateModal={setModalConfirm} eventModal={() => { nullUBL() }}  >
                <div className="row">
                    <div className="col-md-6">
                        <strong>ID Factura </strong><small>{bean.IDUBLInvoice}</small>
                    </div>
                    <div className="col-md-6">
                        <strong>Fecha Factura </strong><small>{bean.IssueDate}</small>
                    </div>
                    <div className="col-md-12">
                        <label >Justificación</label>
                        <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                    </div>
                </div>
            </Modal>


            <Modal modal={modalConfig.modal} updateModal={modalConfig.setModal} eventModal={updateInvoice} >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Utilizar Otra Moneda" estado={bean.UseOtherCurrency} eventChange={(e) => { setBean({ ...bean, UseOtherCurrency: e }) }} />
                    </div>
                    {bean.UseOtherCurrency &&
                        <>
                            <div className="col-md-12">
                                <CurrencyEditor id={bean.IDCurrency} onchange={(e) => { setBean({ ...bean, IDCurrency: e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Tasa de cambio</label>
                                <input type="number" className="form-control" value={bean.ExchangeRate} onChange={(e) => {
                                    const value = e.target.value ? parseFloat(e.target.value) : null;
                                    setBean({ ...bean, ExchangeRate: value })
                                }} />
                            </div>
                        </>
                    }
                </div>
            </Modal>

            <Modal modal={modalConfig2.modal} updateModal={modalConfig2.setModal} eventModal={updateInvoice} >
                <div className="row">
                    <div className="col-md-12">
                        <SelectUBLDocumentPaymentType idSelector={bean.PaymentType} label="Tipo de Pago" onChange={(e) => { setBean({ ...bean, PaymentType: e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Dias de Vencimiento</label>
                        <input type="number" className="form-control" value={bean.DefeatDays} onChange={(e) => {
                            const value = e.target.value ? Number(e.target.value) : null;
                            setBean({ ...bean, DefeatDays: value })
                        }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalApplyPrepaid} updateModal={setModalApplyPrepaid} eventModal={() => { updateInvoice() }}  >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Aplicar Anticipo" estado={bean.ApplyPrepaidValue} eventChange={(e) => { setBean({ ...bean, "ApplyPrepaidValue": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <ReciablePaymentEditor renderValue={bean.PrepaidIDAccountantStr} _Invoice={bean} onChange={(e) => { setBean({ ...bean, "PrepaidIDAccountantStr": e.JsonCode }) }} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _value={bean.PrepaidPayment} onChange={(e) => { setBean({ ...bean, "PrepaidPayment": e }) }} _label="Valor del Anticipo a Cruzar" />
                        {/* <label>Valor del Anticipo a Cruzar</label>
                        <input type="number" className="form-control" value={bean.PrepaidPayment} onChange={(e) => { setBean({ ...bean, "PrepaidPayment": parseFloat(e.target.value) }) }} /> */}
                    </div>
                </div>
            </Modal>
            <Modal modal={modalPro} updateModal={setModalPro} eventModal={getElectronicDocumentProforma}  >
                <div className="row">
                    <div className="col-md-12">
                        <SelectUBLSoftwareDispatcherByEnvironmentType idSelector={ublsoftware} onChange={(e) => { setUblSofteare(e) }} />
                        {/* <SoftwareUBL render={bean.EnvironmentTypeName} idSelector={bean.IDUBLSoftwareDispatcher} onChange={(e) => { setBean({ ...bean, "IDUBLSoftwareDispatcher": e.IDUBLSoftwareDispatcher, "EnvironmentTypeName": e.EnvironmentTypeName }) }} label=" " returnType="Object" /> */}
                    </div>
                </div>
            </Modal>

            <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                <div className="row">
                    <div className="col-md-12">
                        <VisorAnyDocument url={formato} type={type} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalRetenciones} updateModal={setModalRetenciones} >
                <UBLInvoiceTaxSupplier idublInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} />
            </Modal>

        </BasicPage>
    )
}